/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React, { ReactNode } from "react";
import useStyles from "./LogoText.style";
import AppButton from "../AppButton";
import {
  capitalizeFirstLetterAllWords,
  gotoPage,
} from "@/utils/helpers/common";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { useTranslation } from "next-i18next";
import { capitalize } from "lodash";
import { DICTIONARY } from "@/utils/constants/translation.constant";
import { useRouter } from "next/router";
import LinkComponent from "../Link";

export interface HandcraftContentProps {
  title: ReactNode;
  content: ReactNode;
  link?: string;
  image: string;
  imgStyle?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
}

const LogoText: React.FC<HandcraftContentProps> = ({
  title,
  content,
  link,
  image,
  imgStyle,
  titleStyle,
}) => {
  const { locale } = useRouter();
  const { classes } = useStyles({ params: { locale: locale! } });
  const { t } = useTranslation();

  return (
    <div className={classes.logoTextContainer}>
      <div>
        <div className={classes.imgLogoInner} style={imgStyle}>
          <img src={image} alt="Logo Image" className={classes.imgLogo} />
        </div>
      </div>
      <div className={classes.handIcraft}>
        <div className={classes.logoText}>
          <h1 className={classes.handIcraftTitle} style={titleStyle}>
            {title}
          </h1>
          <div className={classes.handIcraftContent}>{content}</div>
          {link ? (
            <div style={{ display: "flex" }}>
              {link ? (
                <div style={{ display: "flex  ", cursor: "pointer" }}>
                  <a onClick={() => gotoPage(link)}>
                    <p className={classes.serviceLink}>
                      {capitalizeFirstLetterAllWords(
                        t(DICTIONARY.BRANCH_LOCATION)
                      )}
                      &nbsp;
                      <img src="/icon/blackArrow.svg"></img>
                    </p>
                  </a>
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogoText;
